import { Component, OnInit } from '@angular/core';
import { ConfigService }  from '../../services/core/config.service';
import { AppService }  from '../../services/app.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-entree',
  templateUrl: './entree.component.html',
  styleUrls: ['./entree.component.scss']
})
export class EntreeComponent implements OnInit {

  constructor(
	public config: ConfigService,
	private ngxLoader: NgxUiLoaderService,
	public appService: AppService
  ) { 
  }

  ngOnInit(): void {
	this.ngxLoader.start();
	this.appService.navActive();
	this.appService.setPageTitle('');
	this.appService.setPageDescription('');
	
	location.href = this.config.get('front_url') + 'auth/authentication/entree';
  }

}
